import {typographyStyles, constants} from '@newsela/angelou';
import {css} from 'emotion';
const {
  textXSObj: text4Obj, heading5Obj
} = typographyStyles;

const {ui} = constants.colors;

export const buttonWithPopOutStyle = {
  buttonContents: {
    maxHeight: '50px',
    svg: {
      height: 'unset'
    }
  },
  PopOut: {
    root: {
      zIndex: '1',
      right: '17rem',
    },
    popOutContents: {
      maxWidth: '350px'
    }
  }
};

export const navMenuListStyles = css({
  width: '350px',
});

export const userSectionStyle = css({
  display: 'grid',
  gridTemplateAreas: `"avatar name"
                      "avatar email"`,
  gridTemplateColumns: 'auto 1fr',
  gridGap: '7px',
  gridTemplateRows: 'auto auto',
  padding: '8px 24px 0'
});

export const avatarArea = css({
  gridArea: 'avatar',
  display: 'flex',
  alignItems: 'center'
});

export const userNameArea = css({
  gridArea: 'name',
  wordBreak: 'break-word',
  ...heading5Obj
});

export const emailArea = css({
  gridArea: 'email',
  wordBreak: 'break-word',
  color: ui.greyLight[700],
  ...text4Obj
});

export const messagesContainer = css({
  width: '100%'
});
